import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ChumonCSVForIwamura} from '../../interfaces/chumon';
import {ShukkaSaki} from '../../interfaces/shukkasaki';
import {MasterService} from '../../../core/service/master.service';
import {CommonService} from '../../../core/service/common.service';
import {FirestoreMasterService} from '../../../core/service/firestore-master.service';
import {COLLECTION_NAME} from '../../constants';
import {AngularFirestore} from '@angular/fire/firestore';
import {MessageService} from '../../../core/service/message.service';

@Component({
  selector: 'app-add-shukkasaki-dialog',
  templateUrl: './add-shukkasaki-dialog.component.html',
  styleUrls: ['./add-shukkasaki-dialog.component.scss']
})
export class AddShukkasakiDialogComponent implements OnInit {
  willAdd = true;
  newShukkaSaki: ShukkaSaki;
  selectedShukkaSaki: ShukkaSaki | null = null;
  constructor(@Inject(MAT_DIALOG_DATA) public data: ChumonCSVForIwamura,
              private firestoreService: FirestoreMasterService,
              private messageService: MessageService,
              private db: AngularFirestore,
              public commonService: CommonService,
              public masterService: MasterService,
              public matDialogRef: MatDialogRef<AddShukkasakiDialogComponent>,) {
    this.newShukkaSaki = {
      id: this.db.createId(),
      name: data.shukkaSakiName,
      shukkaSakiRyakushou: data.shukkaSakiName,
      isDeleted: false
    };
    console.log('AddShukkasakiDialogComponent opened');
  }

  /**
   *
   */
  ngOnInit(): void {
  }

  /**
   * 新規に出荷先を追加する
   */
  register() {
    this.firestoreService.saveMasterDoc(COLLECTION_NAME.SHUKKASAKIMASTER, this.newShukkaSaki, this.newShukkaSaki.id)
      .then(() => {
        // 新規追加した明細もマスタの更新をトリガーとしてマスタサービスで保持している出荷先マスタに追加されるはずだが、
        // 利用するタイミングまでに更新が間に合わない可能性があるので、ここで追加してしまう。
        this.masterService.shukkaSakiMaster.push(this.newShukkaSaki);
        this.messageService.pushInfo('追加しました');
        console.log('document successfully registered!');
        this.commonService.onClick(this.matDialogRef, '1');
      }).catch(error => {
        this.messageService.pushError('追加に失敗しました');
        console.log(error);
      });
  }

  /**
   * 既存の出荷先から選択
   * 選択した値をcsvRowにセット
   */
  selectExistingValue() {
    if (this.selectedShukkaSaki) {
      this.data.shukkaSakiId = this.selectedShukkaSaki.id;
      this.data.shukkaSakiName = this.selectedShukkaSaki.name;
    }
    this.commonService.onClick(this.matDialogRef);
  }
}
